import {React, useState} from 'external/react'
import {styled} from 'external/material'
import StandardsFilters from './StandardsFilters'
import ExpectationsList from './ExpectationsList'
import {toggleSelection} from '../domain/selection.cjs'
import {changeFilter} from '../domain/editions.cjs'
import {enrichPlanningSelection} from '../domain/planning-selection-metadata.cjs'
import useStandardsData from '../hooks/useStandardsData'

const Root = styled('div')(({theme}) => ({display:'flex', flexDirection:'column', gap:theme.spacing(2), width:'100%', minWidth:0}))

// Reusable browsing surface: no TeacherContext, routing or persistence dependency.
// Consumers supply load(entity, parameters), selection and output callbacks.
export default function StandardsSelector ({language, filters: controlledFilters, initialFilters = {}, onFiltersChange, load, selected, onSelectionChange, mode = 'quiz'}) {
  const [localFilters, setLocalFilters] = useState(initialFilters)
  const filters = controlledFilters === undefined ? localFilters : controlledFilters
  const {datasets, retry} = useStandardsData({load, filters, language})
  const change = (name, value) => {
    const next = changeFilter(filters, name, value)
    if (controlledFilters === undefined) setLocalFilters(next)
    if (onFiltersChange) onFiltersChange(next)
  }
  const currentSelection = selected === undefined ? (mode === 'planning' ? [] : {}) : selected
  const toggle = (item, kind) => {
    const candidate = mode === 'planning' ? enrichPlanningSelection(item, kind, filters, datasets) : item
    if (onSelectionChange) onSelectionChange(toggleSelection(mode, currentSelection, candidate, filters, kind))
  }
  return <Root>
    <StandardsFilters filters={filters} datasets={datasets} onChange={change} onRetry={retry}/>
    <ExpectationsList expectations={datasets.expectations?.items || []} dataset={datasets.expectations}
      selected={currentSelection} mode={mode} edition={filters.standard_set} onToggle={toggle} onRetry={() => retry('expectations')}/>
  </Root>
}
